import { BookOpenCheck, Flame, UsersRound } from "lucide-react";

const foundations = [
  {
    label: "Nuestra regla",
    title: "La Biblia",
    icon: BookOpenCheck,
  },
  {
    label: "Nuestra comunión",
    title: "Un mismo sentir",
    icon: UsersRound,
  },
  {
    label: "Nuestra misión",
    title: "Evangelio completo",
    icon: Flame,
  },
];

export default function Actionbar() {
  return (
    <section className="acad-beliefs-foundations" aria-label="Fundamentos de nuestra declaración doctrinal">
      <div className="acad-beliefs-shell acad-beliefs-foundation-grid">
        {foundations.map((foundation, index) => {
          const Icon = foundation.icon;

          return (
            <article key={foundation.title}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <i><Icon aria-hidden="true" /></i>
              <div>
                <small>{foundation.label}</small>
                <strong>{foundation.title}</strong>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
